import { graphql } from "../gql";

const getHeadToHeadFantasyProjectionsQuery = graphql(`
  query GetHeadToHeadFantasyProjections($input: OddsMarketTypesInput!) {
    event(input: $input) {
      playerProjections {
        fantasyPoints
        name
        numberfireId
        teamNumberFireId
        position
        playerPageURL
      }
    }
  }
`);

export default getHeadToHeadFantasyProjectionsQuery;
